
export const DASHBOARD_SET_DATA = 'DASHBOARD_SET_DATA';
export const DASHBOARD_SET_TAG = 'DASHBOARD_SET_TAG';
export const DASHBOARD_SET_TODAY_DATA = 'DASHBOARD_SET_TODAY_DATA';
export const SET_REPORT_OPTIONS = 'SET_REPORT_OPTIONS';
export const SET_SLOT_UPDATING = 'SET_SLOT_UPDATING';
export const SET_ACTIVE_DASHBOARD = 'SET_ACTIVE_DASHBOARD';
export const SET_REPORT_DASHBOARD_DATA = 'SET_REPORT_DASHBOARD_DATA';
export const SET_ALL_REFRESHING = 'SET_ALL_REFRESHING';
export const SET_SLOT_DATA = 'SET_SLOT_DATA';
export const RESET_ACTIVE_DASHBOARD = 'RESET_ACTIVE_DASHBOARD';
export const RESET_DASHBOARD = 'RESET_DASHBOARD';



// WEBPACK FOOTER //
// ./src/views/Dashboard/flow/actionType.js